import React from 'react';
import './Error.css';

export default function Error() {
  return (
    <div className="error-container">
      <div className="error-message">
        404: Page not found
      </div>
    </div>
  );
}
